module.exports = __webpack_public_path__ + "img/product_marketing.4dee5ff9.png";